import flowMixin from '@/modules/Flow/mixins/flowMixin'
import maActionsButtons from '@/components/button-blue'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION,
  UPDATE_LOADER
} from '@/store/types'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import { mapState, mapActions, mapMutations } from 'vuex'
import { apiGetUpptecPdf } from '@/modules/Claim/services/pdf'
import { apiGetMobilierDamages } from '@/modules/Damage/services/damages'
import downloadBlobFile from '@/utils/downloadBlobFile'

export default {
  name: 'claimCompensationMobilier',

  mixins: [flowMixin],

  components: {
    maActionsButtons
  },

  data: function () {
    return {
      mobilierDamages: []
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyHasUpptecDamage: 'hasUpptecDamage'
    }),

    mobilierDamagesTotalAmount() {
      let total = 0
      if (this.mobilierDamages.length > 0) {
        this.mobilierDamages.forEach((damage) => {
          total += damage.amount
        })
      }
      return total
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),

    handlePrimaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.MOBILIER_FINISHED_OK)
    },

    handleSecondaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.MOBILIER_FINISHED_KO)
    },

    handleClickUppTecDossier() {
      apiGetUpptecPdf(this.getSinisterId).then((data) => {
        downloadBlobFile(data, 'Upptec_Dossier.pdf')
      })
    },

    mapMobilierDamages(data) {
      // TODO: update mapper when specific mobilier damages is created
      const { warranties } = data
      const { mobilier: mobilierDamages } = warranties
      if (!mobilierDamages) return []
      const { damages: mobilierDamagesArray } = mobilierDamages

      return mobilierDamagesArray.map((damageData) => {
        const { damage } = damageData
        return {
          name:
            (damage &&
              damage.description &&
              damage.description.split(',')[0]) ||
            '-',
          date: (damage && damage.purchase_date) || '-',
          reference:
            (damage &&
              damage.original_product &&
              damage.original_product.model) ||
            '-',
          amount:
            (damageData &&
              damageData.artessian_repair &&
              damageData.artessian_repair.market_price_with_taxes) ||
            0
        }
      })
    },

    async setMobilierDamages() {
      try {
        if (!this.getSinisterId) return
        const mobilierDamages = await apiGetMobilierDamages(this.getSinisterId)
        this.mobilierDamages = this.mapMobilierDamages(mobilierDamages)
      } catch (e) {
        this.goToErrorView()
      }
    }
  },

  async mounted() {
    this.updateLoader(true)
    this.actGetResultDeclaration(this.getSinisterId)
    await this.setMobilierDamages()
    this.updateLoader(false)
  }
}
